import { useAppData } from '../contexts/AppDataContext';
import { PLAN_NAME_FREE } from '../constants/subscription';

export const useSubscription = () => {
  const { subscriptionData, isLoadingSubscription } = useAppData();

  const isFreeTier = subscriptionData?.plan_name === PLAN_NAME_FREE;
  const isPaidTier = subscriptionData?.is_active && !isFreeTier;
  const planName = subscriptionData?.plan_name ?? null;

  return {
    isFreeTier,
    isPaidTier,
    planName,
    isLoading: isLoadingSubscription,
    subscriptionData,
  };
};
